"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const debounce_1 = __importDefault(require("lodash/debounce"));
const React = __importStar(require("react"));
const ContextMenu_1 = __importDefault(require("../ContextMenu/ContextMenu"));
const styled_1 = __importDefault(require("../utils/styled"));
const constants_1 = require("../utils/constants");
const backgroundColor = "hsla(0, 0%, 100%, 0.1)";
const boxShadow = "0 3px 6px rgba(0, 0%, 0%, 0.3)";
const HeaderContextMenu = styled_1.default(ContextMenu_1.default) `
  height: 100%;
`;
const Container = styled_1.default("div")(({ theme, align, isOpen, withCaret }) => (Object.assign({ width: 250, lineHeight: 1, padding: `${theme.space.content / 2}px ${theme.space.content}px`, height: "100%", [align === "left" ? "paddingRight" : "paddingLeft"]: constants_1.headerHeight, color: isOpen ? theme.color.white : "#ffffffcc", backgroundColor: isOpen ? backgroundColor : "transparent", boxShadow: isOpen ? boxShadow : "none", fontWeight: theme.font.weight.medium, display: "flex", alignItems: "center", justifyContent: align === "left" ? "flex-start" : "flex-end", "& > div": {
        marginLeft: theme.space.small,
    }, "&:hover": {
        boxShadow,
        backgroundColor,
        color: theme.color.white,
    } }, (withCaret
    ? {
        "&::after": {
            content: "''",
            position: "absolute",
            top: "50%",
            [align === "left" ? "right" : "left"]: theme.space.content,
            width: 0,
            height: 0,
            border: "4px solid transparent",
            borderTopColor: "#ffffff80",
            transform: "translateY(calc(-50% + 2px))",
        },
        "&:hover": {
            boxShadow,
            backgroundColor,
            color: theme.color.white,
            "&::after": {
                borderTopColor: theme.color.white,
            },
        },
    }
    : {}))));
class HeaderMenu extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            renderedMenuWidth: 0,
        };
        this.$menu = React.createRef();
        /**
         * Explicit typing is required here in order to give the typescript compiler access to typings
         * used to work out type definitions for the debounce method.
         * @todo look into making this unnecessary.
         */
        this.handleResize = debounce_1.default(() => {
            this.updateRenderedWidth();
        }, 200);
    }
    componentDidMount() {
        this.updateRenderedWidth();
        window.addEventListener("resize", this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    componentDidUpdate() {
        this.updateRenderedWidth();
    }
    updateRenderedWidth() {
        if (!this.$menu || this.$menu.current === null) {
            return;
        }
        const node = this.$menu.current;
        const renderedMenuWidth = node.clientWidth;
        if (renderedMenuWidth !== this.state.renderedMenuWidth) {
            this.setState(() => ({
                renderedMenuWidth,
            }));
        }
    }
    render() {
        const props = this.props;
        return (React.createElement(HeaderContextMenu, Object.assign({ width: this.state.renderedMenuWidth }, props), isOpen => (React.createElement(Container, { ref: this.$menu, isOpen: isOpen, align: props.align, withCaret: Boolean(props.withCaret) }, props.children))));
    }
}
HeaderMenu.defaultProps = {
    align: "left",
    withCaret: false,
};
exports.default = HeaderMenu;
//# sourceMappingURL=HeaderMenu.js.map